import React, { useEffect, useState, useMemo } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Images } from '../../utils/Images';
import { fetchCmsHomeAction } from '../../store/slices/cmsSlice';

const WhatsAppButton = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isBelow1800 = useMediaQuery('(max-width:1800px)');
  const [bottomOffset, setBottomOffset] = useState(20);
  const dispatch = useDispatch();
  const cmsHome = useSelector((state) => state.cms.home);

  useEffect(() => {
    if (!cmsHome) {
      dispatch(fetchCmsHomeAction());
    }
  }, [cmsHome, dispatch]);

  useEffect(() => {
    const updateOffset = () => {
      if (typeof document === 'undefined') return;
      const donationBox = document.querySelector('[data-donation-box="true"]');
      if (donationBox && isBelow1800) {
        const rect = donationBox.getBoundingClientRect();
        const height = Math.max(0, (rect?.height || donationBox.offsetHeight || 0) - 21);
        const gap = isMobile ? 26 : 20; // add a bit more space on mobile
        setBottomOffset(height + gap);
      } else {
        setBottomOffset(isMobile ? 26 : 10); // slightly higher on mobile for breathing room
      }
    };

    updateOffset();

    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(updateOffset);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
      window.addEventListener('resize', updateOffset);
      return () => {
        observer.disconnect();
        window.removeEventListener('resize', updateOffset);
      };
    }

    window.addEventListener('resize', updateOffset);
    return () => {
      window.removeEventListener('resize', updateOffset);
    };
  }, [isBelow1800, isMobile]);

  const { phoneNumber, message } = useMemo(() => {
    const sections = Array.isArray(cmsHome?.data) ? cmsHome.data : [];
    const section = sections.find(
      (s) => s?.id === 108 && (s?.status === 1 || s?.status === true)
    );
    const cmsPhone = typeof section?.title === 'string' && section.title.trim()
      ? section.title.trim()
      : '';
    const cmsMessage = typeof section?.description === 'string' && section.description.trim()
      ? section.description.trim()
      : '';

    return {
      phoneNumber: cmsPhone,
      message: cmsMessage,
    };
  }, [cmsHome]);

  if (!phoneNumber) {
    return null;
  }

  const isVendorDetailPage = location.pathname.startsWith('/small-vendors/detail');
  const vendorDetailExtraOffset = isMobile && isVendorDetailPage ? 58 : 0;
  const effectiveBottomOffset = bottomOffset + vendorDetailExtraOffset;

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <Box
      onClick={handleWhatsAppClick}
      sx={{
        position: 'fixed',
        bottom: `${effectiveBottomOffset}px`,
        right: { xs: '10px', sm: '10px' },
        backgroundColor: '#25D366',
        borderRadius: '50px',
        padding: {
          xs: '10px',
          sm: '12px 20px',
        },
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(37, 211, 102, 0.3)',
        transition: 'all 0.3s ease',
        zIndex: 1200,
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: '0 6px 16px rgba(37, 211, 102, 0.4)',
        },
        '&:active': {
          transform: 'scale(0.95)',
        },
      }}
    >
      <img
        src={Images.whatsapp}
        alt="WhatsApp"
        style={{
          width: '24px',
          height: '24px',
          filter: 'brightness(0) invert(1)',
        }}
      />
      <Box
        sx={{
          display: {
            xs: 'none',
            sm: 'flex',
          },
          flexDirection: 'column',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: 'white',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: 1,
          }}
        >
          Chat with us on
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'white',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: 1,
          }}
        >
          WhatsApp
        </Typography>
      </Box>
    </Box>
  );
};

export default WhatsAppButton;






// import React, { useState, useEffect } from 'react';
// import { Box, Typography } from '@mui/material';
// import { Images } from '../../utils/Images';

// const WhatsAppButton = () => {
//   const [donationBoxHeight, setDonationBoxHeight] = useState(0);

//   // Check if donation box is present and get its height
//   useEffect(() => {
//     const checkDonationBox = () => {
//       // Look for donation box by checking if it exists in the DOM
//       const donationBox = document.querySelector('[data-donation-box="true"]');
//       if (donationBox) {
//         const height = donationBox.offsetHeight;
//         setDonationBoxHeight(height + 20); // Add 20px margin
//       } else {
//         setDonationBoxHeight(0);
//       }
//     };

//     // Check initially
//     checkDonationBox();

//     // Set up observer to watch for donation box changes
//     const observer = new MutationObserver(checkDonationBox);
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//     });

//     return () => observer.disconnect();
//   }, []);

//   const handleWhatsAppClick = () => {
//     // You can customize the phone number and message here
//     const phoneNumber = '+919876543210'; // Replace with actual phone number
//     const message = 'Hello! I would like to know more about Truehope Foundation.';
//     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
//     window.open(whatsappUrl, '_blank');
//   };

//   return (
//     <Box
//       onClick={handleWhatsAppClick}
//       sx={{
//         position: 'fixed',
//         bottom: donationBoxHeight > 0 ? `${donationBoxHeight}px` : '20px',
//         right: '20px',
//         backgroundColor: '#25D366', // WhatsApp green color
//         borderRadius: '50px',
//         padding: {
//           xs: '7px', // Mobile: just padding for circular button
//           sm: '10px 46px 10px 16px', // Desktop: padding for text button
//         },
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         cursor: 'pointer',
//         boxShadow: '0 4px 12px rgba(37, 211, 102, 0.3)',
//         transition: 'all 0.3s ease',
//         zIndex: 1000,
//         '&:hover': {
//           transform: 'scale(1.05)',
//           boxShadow: '0 6px 16px rgba(37, 211, 102, 0.4)',
//         },
//         '&:active': {
//           transform: 'scale(0.95)',
//         },
//       }}
//     >
//       <img
//         src={Images.whatsapp}
//         alt="WhatsApp"
//         style={{
//           width: '36px',
//           height: '36px',
//           filter: 'brightness(0) invert(1)', // Makes the icon white
//         }}
//       />
//       <Box 
//         sx={{ 
//           // display: 'flex', 
//           flexDirection: 'column', 
//           gap: '2px',
//           display: {
//             xs: 'none', // Hide text on mobile
//             sm: 'flex', // Show text on desktop
//           }
//         }}
//       >
//         <Typography
//           variant="body2"
//           sx={{
//             color: 'white',
//             fontFamily: 'Red Hat Display',
//             fontSize: '14px',
//             fontWeight: 500,
//             fontStyle: 'normal',
//             lineHeight: '24px',
//             letterSpacing: '0%',
//           }}
//         >
//           Chat with us on
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{
//             color: 'white',
//             fontFamily: 'Red Hat Display',
//             fontSize: '20px',
//             fontWeight: 700,
//             fontStyle: 'normal',
//             lineHeight: '100%',
//             letterSpacing: '0%',
//           }}
//         >
//           WhatsApp
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default WhatsAppButton;

